import React from 'react';
import { DialogTitle, Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon, CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import { colors, fonts, spacing } from '../../../constants';
import {
  dialogTitleStyles,
  headerIconBoxStyles,
  closeButtonStyles,
  ICON_SIZES,
  IMPORT_COLORS,
} from '../../../constants/importDialog';

/**
 * ImportDialogHeader Component
 * Header section for ImportDialog with icon, title, and close button
 */
const ImportDialogHeader = ({ onClose, submitting }) => {
  return (
    <DialogTitle sx={dialogTitleStyles}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: spacing.sm }}>
        <Box sx={headerIconBoxStyles}>
          <CloudUploadIcon sx={{ fontSize: ICON_SIZES.HEADER_ICON_INNER, color: colors.textWhite }} />
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: fonts.weightBold,
            fontSize: ICON_SIZES.TITLE_FONT,
            color: colors.textPrimaryDark,
          }}
        >
          Import Users
        </Typography>
      </Box>
      <IconButton onClick={onClose} size="small" disabled={submitting} sx={closeButtonStyles}>
        <CloseIcon sx={{ fontSize: ICON_SIZES.CLOSE_ICON }} />
      </IconButton>
    </DialogTitle>
  );
};

export default ImportDialogHeader;
